import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { object } from 'prop-types'
import { withContext } from '../../../utils/withContext'
import styles from './SimpleMenu.styl'
import MobileMenu from '../MobileMenu/MobileMenu'

class SimpleMenu extends React.Component {

	static propTypes = {
		session: object,
		context: object
	}

	static getDerivedStateFromProps(props) {
		const { context: { i18n, createLocaleLink, renderLocales } } = props
		return {
			navigation: [
				{ name: i18n`menu_objectivos_label`, to: createLocaleLink('/#challenges') },
				{ name: i18n`menu_missão_label`, to: createLocaleLink('/#mission') },
				{ name: i18n`menu_paulo_label`, to: createLocaleLink('/#curriculum') },
				{ name: i18n`menu_testemunhos_label`, to: createLocaleLink('/#testimonials') },
				{ name: i18n`menu_serviços_label` },
				{ name: i18n`menu_contactos_label`, to: createLocaleLink('/#contacts') },
				{ name: i18n`menu_login_label`, to: createLocaleLink('/login') },
				{ name: i18n`menu_registo_label`, to: createLocaleLink('/registry') },
				...renderLocales()
			]
		}
	}

	state = {
		hasBackground: false,
		isMenuOpen: false
	}
	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll.bind(this))
	}
	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll.bind(this))
	}
	handleScroll() {
		this.setState({ hasBackground: window.scrollY >= 40 })
	}
	handleRevoke() {
		const { context: { createLocaleLink } } = this.props
		fetch('/api/accounts/revoke', {
			method: 'DELETE',
			credentials: 'include'
		})
			.then(() => {
				window.location = createLocaleLink('/')
			})
			.catch(e => e)
	}
	renderNavigation(userName, navigation) {
		const { context: { renderLocales } } = this.props
		const sessionItem = [{ name: userName, to: '/apt/workout/daily' }, { name: 'Logout', action: this.handleRevoke.bind(this) }, ...renderLocales()]
		return (userName ? (navigation.slice(0, navigation.length - 3).concat(sessionItem)) : navigation).map((item, index) => (
			<li
				key={ index }
				className={ styles['nav-entry'] }
				style={ { animationDelay: `${ (index * 100) + 250 }ms` } }
				onClick={ item.action ? item.action : null }
			>
				{ item.to ? <Link to={ item.to }>{ item.name }</Link> : item.name }
			</li>
		))
	}
	render() {
		const { session, context: { createLocaleLink, renderLocales } } = this.props
		const { hasBackground, isMenuOpen, navigation } = this.state
		const sessionItem = [{ name: session.name, to: createLocaleLink('/apt/workout/daily') }, { name: 'Logout', action: this.handleRevoke.bind(this) }, ...renderLocales()]
		const parsedNavigation = (session.name ? (navigation.slice(0, navigation.length - 3).concat(sessionItem)) : navigation)

		const backgroundClass = hasBackground ? styles['hasBackground'] : ''
		return (
			<section className={ `${ styles['menu'] } ${ backgroundClass }` } >
				<div className={ styles.content }>
					<div className={ styles['logo-container'] }>
						<Link to={ createLocaleLink('/') } onClick={ () => { this.setState(prevState => ({ isMenuOpen: false })) } }><img className={ styles['logo'] } src="http://i.imgur.com/RFnxWBP.png" /></Link>
					</div>
					<div className={ styles['navigation-links'] }>
						<ul className={ styles['navigation-list'] }>
							{ this.renderNavigation(session.name, parsedNavigation) }
						</ul>
						<div className={ styles['mobile-menu-container'] }>
							{ isMenuOpen ?
								<MobileMenu
									navigation={ parsedNavigation }
									className={ styles['mobile'] }
									closeMenu={ () => { this.setState({ isMenuOpen: false }) } }
								/> :
								null
							}
							<div onClick={ () => { this.setState(prevState => ({ isMenuOpen: !prevState.isMenuOpen })) } }>
								<span className={ `${ styles['burger'] } ${ isMenuOpen ? styles['is-open'] : '' }` }><span /></span>
							</div>
						</div>


					</div>
				</div>
			</section >
		)
	}
}

const mapStateToProps = state => ({
	session: state.session
})

export default withContext(connect(mapStateToProps)(SimpleMenu))



// WEBPACK FOOTER //
// ./src/client/website/components/SimpleMenu/SimpleMenu.js